(function () {
  const CHECKOUT_BUTTON_SELECTOR = '[data-precheckout-capture="true"]';

  async function getCart() {
    const response = await fetch(window.Shopify.routes.root + 'cart.js', {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('No se pudo leer el carrito.');
    }

    return response.json();
  }

  async function updateCartLineProperties(lineKey, newDeliveryData, cart) {
    const item = cart.items.find(function (cartItem) {
      return cartItem.key === lineKey;
    });

    if (!item) {
      return;
    }

    const existingProperties = item.properties || {};

    const updatedProperties = {
      ...existingProperties,
      _disponibilidad_en_compra: newDeliveryData.disponibilidad || '',
      _fecentrega_en_compra_iso: newDeliveryData.fecentregaIso || '',
      _fecentrega_en_compra_visible: newDeliveryData.fecentregaVisible || '',
      _captura_precheckout_timestamp: Math.floor(Date.now() / 1000).toString()
    };

    const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: item.quantity,
        properties: updatedProperties
      })
    });

    if (!response.ok) {
      throw new Error('No se pudieron actualizar las propiedades del carrito.');
    }

    return response.json();
  }

  function getCurrentLineDataFromPage() {
    const elements = document.querySelectorAll('.js-precheckout-line-data');
    const dataByLineKey = new Map();

    elements.forEach(function (element) {
      const lineKey = element.dataset.lineKey;

      if (!lineKey) {
        return;
      }

      dataByLineKey.set(lineKey, {
        disponibilidad: element.dataset.disponibilidad || '',
        fecentregaIso: element.dataset.fecentregaIso || '',
        fecentregaVisible: element.dataset.fecentregaVisible || ''
      });
    });

    return dataByLineKey;
  }

  async function captureDeliveryDataBeforeCheckout() {
    const lineData = getCurrentLineDataFromPage();

    if (lineData.size === 0) {
      return;
    }

    const cart = await getCart();

    for (const [lineKey, deliveryData] of lineData.entries()) {
      await updateCartLineProperties(lineKey, deliveryData, cart);
    }
  }

  async function handleCheckoutClick(event) {
    const trigger = event.target.closest(CHECKOUT_BUTTON_SELECTOR);

    if (!trigger) {
      return;
    }

    if (trigger.dataset.precheckoutUpdating === 'true') {
      event.preventDefault();
      return;
    }

    event.preventDefault();

    trigger.dataset.precheckoutUpdating = 'true';

    const originalText = trigger.tagName === 'INPUT'
      ? trigger.value
      : trigger.textContent;

    if (trigger.tagName === 'INPUT') {
      trigger.value = 'Preparando pedido...';
    } else {
      trigger.textContent = 'Preparando pedido...';
    }

    try {
      await captureDeliveryDataBeforeCheckout();

      const href = trigger.getAttribute('href');

      if (href) {
        window.location.href = href;
        return;
      }

      const form = trigger.closest('form');

      if (form && typeof form.requestSubmit === 'function') {
        form.requestSubmit(trigger);
        return;
      }

      window.location.href = window.Shopify.routes.root + 'checkout';
    } catch (error) {
      console.error(error);

      trigger.dataset.precheckoutUpdating = 'false';

      if (trigger.tagName === 'INPUT') {
        trigger.value = originalText;
      } else {
        trigger.textContent = originalText;
      }

      alert('No se pudo preparar el pedido. Por favor, inténtalo de nuevo.');
    }
  }

  document.addEventListener('click', handleCheckoutClick);
})();